module.exports = (Promise.resolve(__parcel__require__("./" + "Doppio.5a8f63ac.9718100c.js"))).then(() => parcelRequire('lJzoe'));